import { Component, Inject, forwardRef, OnInit, PLATFORM_ID, Input } from '@angular/core';
import { NgAisInstantSearch } from 'angular-instantsearch';
import { connectRefinementList } from 'instantsearch.js/es/connectors';
import { CatalogWidgetDirective, IBaseItem } from '../catalog-widget';
import { ToggleFacets } from '@app/shared/components/catalog/services/filters.service';

@Component({
  selector: 'vc-catalog-widget-checkbox-list',
  templateUrl: './catalog-widget-checkbox-list.component.html',
  styleUrls: ['./catalog-widget-checkbox-list.component.scss', '../catalog-widgets.scss']
})
export class CatalogWidgetCheckboxListComponent extends CatalogWidgetDirective implements OnInit {
  state: {
    items: IBaseItem[];
    createURL: () => string;
    refine: (value: string) => void;
    searchForItems: (value: string) => void;
    isFormSearch: boolean;
    canRefine: boolean;
    widgetParams: {};
    canToggleShowMore: boolean;
    isShowingMore: boolean;
    toggleShowMore: () => {};
  };

  public toggleFacets = ToggleFacets;

  public expertArray = ['Verkaufsexperte', 'Experte', 'Expert', 'Esperto', 'Experto'];
  public trustedArray = [
    'Vertrauenswürdiger Verkäufer',
    'Trusted',
    'Conformidad',
    'Recommandé',
    'Affidabile',
    'De Confianza'
  ];

  @Input()
  nbHits: number;

  constructor(
    @Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    super('CatalogWidgetCheckboxListComponent', platformId);
  }
  get searchPlaceholder(): string {
    return this.options.searchPlaceholder || 'CATALOG.FILTERS.SEARCH_PLACEHOLDER.DEFAULT';
  }

  ngOnInit() {
    let widgetConfig = {
      limit: this.options.limit,
      attributeName: this.options.facet,
      sortBy: this.options.sortBy ? this.options.sortBy : ['name:asc'],
      showMoreLimit: this.options.showMoreLimit,
      canToggleShowMore: true,
      isShowingMore: true
    };

    if (this.isServer && ['CATALOG.FILTERS.MODEL', 'CATALOG.FILTERS.MATERIALS'].indexOf(this.options.label) > -1) {
      widgetConfig = {
        ...widgetConfig,
        ...{
          canToggleShowMore: false,
          limit: 50,
          showMoreLimit: 50
        }
      };
    }

    this.createWidget(connectRefinementList, widgetConfig);
    super.ngOnInit();
  }

  /**
   * Return URl of Discount filter for SEO
   */
  get getDiscountUrl(): string {
    let result = null;
    if (this.isServer && this.facetLink && this.facetLink.editorPicks && this.nbHits && this.nbHits >= 4) {
      const found = this.facetLink.editorPicks.find(element => element.facetId === 'sale');
      if (found) {
        result = found.path;
      }
    }

    return result;
  }
}
